import { Vector3 } from "three";

// Math constants that are regularly used
export const TWO_PI = Math.PI * 2;
export const PI = Math.PI;
export const HALF_PI = Math.PI / 2;
export const QUARTER_PI = Math.PI / 4;
export const VECTOR_ZERO = new Vector3();
export const VECTOR_ONE = new Vector3(1, 1, 1);
export const VECTOR_UP = new Vector3(0, 1, 0);
